export default class OrgChartDto {
	public id: number;
	public styled: string;
	public rol: string;
	public reportsTo: number | null;
}
